import R from "ramda";

export default val => {
  if (R.type(val) === "String") {
    return val ? JSON.parse(val) : {};
  }
  return val;
};
